import { EditSmall } from "@wix/wix-ui-icons-common";
import cx from "classnames";
import React, { useContext } from "react";
import { ADD_CAPTION_BUTTON } from "./../../plugin-figure/data-hooks.js";
import { RicosContext } from "./../../ricos-context/index.js";
import classes from "./add-caption-button-scss.js";
const AddCaptionButton = ({ onAddCaption, showIcon }) => {
  const { t, isMobile } = useContext(RicosContext);
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onAddCaption();
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classes.addCaptionButtonContainer,
      contentEditable: false,
      suppressContentEditableWarning: true
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: cx(classes.addCaptionButton, {
          [classes.mobile]: isMobile,
          [classes.withIcon]: showIcon
        }),
        onClick: handleClick,
        onMouseDown: (e) => {
          e.preventDefault();
          e.stopPropagation();
        },
        onTouchEnd: isMobile ? handleClick : void 0,
        "data-hook": ADD_CAPTION_BUTTON,
        type: "button",
        "aria-label": t("Figure_Caption_AddButton_AriaLabel")
      },
      showIcon && /* @__PURE__ */ React.createElement(EditSmall, null),
      t("Figure_Caption_AddButton_Title")
    )
  );
};
export {
  AddCaptionButton
};
//# sourceMappingURL=add-caption-button.js.map
